import { createReducer } from "@reduxjs/toolkit";
import type { AdminTeacherPayoutVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { adminRetrieveTeacherPayouts } from "./retrieve-teacher-payouts";
import type { RetrievalState } from "@redux/state/shared-types";
import type { PaginatedResult } from "@shared-kernel/domain/types/paginated-result";

const initialState: RetrievalState<PaginatedResult<AdminTeacherPayoutVM>> = {
  fetching: "idle",
  data: {
    items: [],
    page: 1,
    pageSize: 50,
    total: 0,
    totalPages: 0,
  },
};

export const adminRetrieveTeacherPayoutsReducer = createReducer(initialState, builder => {
  builder
    .addCase(adminRetrieveTeacherPayouts.pending, state => {
      return {
        ...state,
        fetching: "pending",
      };
    })
    .addCase(adminRetrieveTeacherPayouts.fulfilled, (state, { payload }) => {
      return {
        ...state,
        data: payload,
        fetching: "success",
      };
    })
    .addCase(adminRetrieveTeacherPayouts.rejected, state => {
      return {
        ...state,
        fetching: "failed",
      };
    });
});
